import { render, staticRenderFns } from "./Login_TalentoHumano.vue?vue&type=template&id=1a953bc2&scoped=true&lang=html"
import script from "./Login_TalentoHumano.vue?vue&type=script&lang=js"
export * from "./Login_TalentoHumano.vue?vue&type=script&lang=js"
import style0 from "./Login_TalentoHumano.vue?vue&type=style&index=0&id=1a953bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a953bc2",
  null
  
)

export default component.exports